module.exports = __webpack_public_path__ + "static/media/trak.anoxic.me.3673fae9.png";